import React from "react";
import { Particles } from "@blackbox-vision/react-particles";

const ParticleBackground = () => {
  return (
    <Particles
      id="simple"
      width="auto"
      height="100vh"
      style={{
        backgroundColor: "dark",
      }}
      params={{
        particles: {
          number: {
            value: 60,
          },
          size: {
            value: 5,
          },
        },
        interactivity: {
          events: {
            onhover: {
              enable: true,
              mode: "repulse",
            },
          },
        },
      }}
    />
  );
};

export default ParticleBackground;
